export const SsoAcceptActionTypes = {
  REQUEST: 'SSO_ACCEPT_REQUEST',
  SUCCESS: 'SSO_ACCEPT_SUCCESS',
  FAILURE: 'SSO_ACCEPT_FAILURE',
};
